export enum FiltersEvent {
    APPLY = 'filters:apply',
    EDIT = 'filters:edit',
}

export interface FiltersEditPayload {
    name: string;
    label: string | string[];
    translation?: string;
    component?: string;
    active?: boolean;
}

export interface FiltersEventMap {
    [FiltersEvent.APPLY]: void;
    [FiltersEvent.EDIT]: FiltersEditPayload;
}
